import { IPurchaseState } from "../entities/PurchaseState";

export const purchaseStateContainsAnchor = (purchaseState: IPurchaseState): boolean =>
  purchaseState.schedule ? Object.keys(purchaseState.schedule.anchor).length > 0 : false;

export const purchaseStateListContainAnchors = (purchaseStates: IPurchaseState[]): boolean =>
  purchaseStates.some(cps => purchaseStateContainsAnchor(cps));
